import { useQuery } from "@tanstack/react-query";
import {
  fetchCompareSuggestions,
  type CompareSuggestionsResponse,
} from "@/services/compare_api";

export const compareSuggestionKeys = {
  all: ["compareSuggestions"] as const,
  byFlavor: (id: string) => ["compareSuggestions", id] as const,
};

export function useCompareSuggestions(flavorId: string | null) {
  return useQuery<CompareSuggestionsResponse>({
    queryKey:
      flavorId !== null
        ? compareSuggestionKeys.byFlavor(flavorId)
        : compareSuggestionKeys.byFlavor("__none__"),
    queryFn: ({ signal }) => fetchCompareSuggestions(flavorId!, signal),
    enabled: flavorId !== null,
    staleTime: 60_000,
  });
}
